// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelFormBody-SectionTitle_cls1__75zuK","cls2":"PaymentChannelFormBody-SectionTitle_cls2__4sDCO PaymentChannelFormBody-SectionTitle_cls1__75zuK"};